<template>
  <div class="Index">
    <div class="libe_home_nav" v-if="scroll >= 88">
      <headNav :activeNav="'Inicio'"></headNav>
    </div>
    <div class="libe_home_wrap">
      <div class="libe_homenav" v-if="scroll < 88">
        <homeNav :activeNav="'Inicio'"></homeNav>
      </div>

      <div class="banner_useview">
        <banner></banner>
      </div>

      <div class="home_middle_wrap">
        <div class="home_middle_title">
          El máximo de préstamo con información de identidad
        </div>
        <div class="home_middle_amount">
          <img src="../assets/image/home_middle_amount.png" />
        </div>
        <div class="home_middle_btns">
          <van-button round color="#006747" block style="height: 100px">
            <span style="font-size: 32px; font-weight: bold; letter-spacing: 1px; text-shadow: 0px 1px 4px rgba(0,0,0,0.28);">Ir Prestado</span>
          </van-button>
        </div>
        <div class="home_middle_desc_view">
          <img src="../assets/image/home_middle_desc.png" />
        </div>
      </div>

      <div class="step_wrap">
        <div class="step_cont">
          <div class="step_cleft">
            <van-steps direction="vertical" :active="step_active" @click-step="onStep">
              <van-step>
                <template #active-icon>
                  <div class="active_iconview">
                    <img src="../assets/image/active_icon01.png" />
                  </div>
                </template>
                <template #inactive-icon>
                  <div class="normal_iconview">
                    <img src="../assets/image/normal_icon01.png" />
                  </div>
                </template>

                <div class="step_citems" :class="step_active == 0 ? 'step_citemsone' : 'step_citems_normal'">
                  <div class="step_citem">
                    <template v-if="step_active == 0">
                      <div class="step_cititle">Registrarse</div>
                      <div class="step_ciborder"></div>
                      <div class="step_cidesc">Verificar en solo 3 minutos. Si se aprueba, haz clic en confirmar préstamo y su cuenta bancaria recibirá el dinero inmediatamente.</div>
                    </template>
                    <template v-else>
                      <div class="step_cititle_normal">Registrarse</div>
                    </template>
                  </div>
                </div>
              </van-step>
              <van-step>
                <template #active-icon>
                  <div class="active_iconview">
                    <img src="../assets/image/active_icon02.png" />
                  </div>
                </template>
                <template #inactive-icon>
                  <div class="normal_iconview">
                    <img src="../assets/image/normal_icon02.png" />
                  </div>
                </template>

                <div class="step_citems" :class="step_active == 1 ? 'step_citemstwo' : 'step_citems_normal'">
                  <div class="step_citem">
                    <template v-if="step_active == 1">
                      <div class="step_cititle">Solicitar un Préstamo</div>
                      <div class="step_ciborder"></div>
                      <div class="step_cidesc">Elija el monto y el plazo del préstamo según su necesidad, y enviar la solicitud de préstamo y ver los resultados de la verificación.</div>
                    </template>
                    <template v-else>
                      <div class="step_cititle_normal">Solicitar un Préstamo</div>
                    </template>
                  </div>
                </div>
              </van-step>
              <van-step>
                <template #active-icon>
                  <div class="active_iconview">
                    <img src="../assets/image/active_icon03.png" />
                  </div>
                </template>
                <template #inactive-icon>
                  <div class="normal_iconview">
                    <img src="../assets/image/normal_icon03.png" />
                  </div>
                </template>

                <div class="step_citems" :class="step_active == 2 ? 'step_citemsthr' : 'step_citems_normal'">
                  <div class="step_citem">
                    <template v-if="step_active == 2">
                      <div class="step_cititle">Obtener un préstamo</div>
                      <div class="step_ciborder"></div>
                      <div class="step_cidesc">Verificar en solo 3 minutos. Si se aprueba, haz clic en confirmar préstamo y su cuenta bancaria recibirá el dinero inmediatamente.</div>
                    </template>
                    <template v-else>
                      <div class="step_cititle_normal">Obtener un préstamo</div>
                    </template>
                  </div>
                </div>
              </van-step>
              <van-step>
                <template #active-icon>
                  <div class="active_iconview">
                    <img src="../assets/image/active_icon04.png" />
                  </div>
                </template>
                <template #inactive-icon>
                  <div class="normal_iconview">
                    <img src="../assets/image/normal_icon04.png" />
                  </div>
                </template>

                <div class="step_citems" :class="step_active == 3 ? 'step_citemsfur' : 'step_citems_normal'">
                  <div class="step_citem">
                    <template v-if="step_active == 3">
                      <div class="step_cititle">Reembolsar a tiempo</div>
                      <div class="step_ciborder"></div>
                      <div class="step_cidesc">Para aumentar su límite de crédito y evitar multas, debes pagar el préstamo a tiempo en la fecha de pago.</div>
                    </template>
                    <template v-else>
                      <div class="step_cititle_normal">Reembolsar a tiempo</div>
                    </template>
                  </div>
                </div>
              </van-step>
              <van-step>
                <template #active-icon>
                  <div class="active_iconview">
                    <img src="../assets/image/active_icon05.png" />
                  </div>
                </template>
                <template #inactive-icon>
                  <div class="normal_iconview">
                    <img src="../assets/image/normal_icon05.png" />
                  </div>
                </template>

                <div class="step_citems" :class="step_active == 4 ? 'step_citemsfiv' : 'step_citems_normal'">
                  <div class="step_citem">
                    <template v-if="step_active == 4">
                      <div class="step_cititle">Reaplicar un préstamo</div>
                      <div class="step_ciborder"></div>
                      <div class="step_cidesc">Estamos felices de ayudarle a alcanzar la vida de sus sueños y esperamos poder ayudarle de nuevo.</div>
                    </template>
                    <template v-else>
                      <div class="step_cititle_normal">Reaplicar un préstamo</div>
                    </template>
                  </div>
                </div>
              </van-step>
            </van-steps>

          </div>
          <div class="step_cright">
            <div class="step_cright_img">
              <template v-if="step_active == 0">
                <img src="../assets/image/step_cright_img01.png" />
              </template>
              <template v-else-if="step_active == 1">
                <img src="../assets/image/step_cright_img02.png" />
              </template>
              <template v-else-if="step_active == 2">
                <img src="../assets/image/step_cright_img03.png" />
              </template>
              <template v-else-if="step_active == 3">
                <img src="../assets/image/step_cright_img04.png" />
              </template>
              <template v-else-if="step_active == 4">
                <img src="../assets/image/step_cright_img05new.png" />
              </template>
            </div>
          </div>
        </div>
      </div>

    </div>
    <footPage></footPage>
  </div>
</template>

<script>
import headNav from "@/components/headNav.vue";
import homeNav from "@/components/homeNav.vue";
import footPage from "@/components/foot.vue";
import banner from "@/components/banner.vue";

export default {
    name: 'Index',
    components: { headNav, homeNav, banner, footPage },
    data () {
      return {
        scroll: 0,
        step_active: 0,
      }
    },
    created() {

    },
    mounted(){
      window.addEventListener('scroll',this.handleScroll)
    },
    methods: {
      handleScroll(){
        this.scroll = document.documentElement.scrollTop||document.body.scrollTop
      },
      onStep(index){
        console.log(index)
        this.step_active = index;
      }
    },
    destroyed() {
      window.removeEventListener('scroll', this.handleScroll)
    }
  }
</script>

<style>
  .libe_home_wrap{
    width: 100%;
    height: auto;
    position: relative;
  }
  .libe_home_nav{
    width: 100%;
    height: auto;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 1010;
  }
  .libe_homenav{
    width: 100%;
    height: auto;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 8;
  }

  .libe_home_top_img img{
    display: block;
    width: 100%;
  }

  .libe_home_down img{
    display: block;
    width: 100%;
  }
  .banner_useview {
    width: 100%;
    padding-top: 90px;
  }
  .home_middle_wrap{
    width: 100%;
    height: 1043px;
    background: #F7FCFA;
    box-sizing: border-box;
    padding-top: 140px;
    padding-bottom: 65px;
  }
  .home_middle_title{
    width: 850px;
    height: 187px;
    font-size: 38px;
    font-weight: bold;
    color: #1E3C33;
    line-height: 56px;
    letter-spacing: 1px;
    text-align: center;
    margin: 0 auto;
  }
  .home_middle_amount{
    width: 420px;
    height: 125px;
    margin: 0 auto;
  }
  .home_middle_amount img{
    display: block;
    width: 420px;
    height: 125px;
  }
  .home_middle_btns{
    width: 520px;
    height: 100px;
    margin: 46px auto 0 auto;
  }
  .home_middle_desc_view{
    width: 1300px;
    height: 314px;
    margin: 79px auto 0 auto;
  }
  .home_middle_desc_view img{
    display: block;
    width: 1300px;
    height: 314px;
  }

  .step_wrap{
    width: 1200px;
    height: auto;
    background: #FFFFFF;
    box-sizing: border-box;
    padding: 169px 0 57px 92px;
    margin: 0 auto;
  }
  .step_cont{
    width: 100%;
    height: auto;
    display: flex;
    justify-content: flex-start;
  }
  .step_cleft{
    width: 690px;
    height: auto;
    cursor: pointer;
  }
  .step_citems{
    width: 100%;
    height: auto;
    box-sizing: border-box;
    margin-left: 48px;
    position: relative;
  }
  .step_citem{
    width: 100%;
    height: auto;
    position: absolute;
    left: 0;
    top: -22px;
  }
  .step_cititle{
    width: 420px;
    height: 77px;
    font-size: 36px;
    font-weight: bold;
    color: #006747;
    line-height: 58px;
    letter-spacing: 1px;
  }
  .step_cititle_normal{
    width: 420px;
    height: auto;
    font-size: 24px;
    font-weight: 600;
    color: #1E8666;
    line-height: 32px;
    padding-top: 16px;
  }
  .step_ciborder{
    width: 420px;
    height: 2px;
    background: #006747;
  }
  .active_iconview{
    width: 80px;
    height: 80px;
  }
  .active_iconview img{
    display: block;
    width: 80px;
    height: 80px;
  }
  .normal_iconview{
    width: 40px;
    height: 40px;
  }
  .normal_iconview img{
    display: block;
    width: 40px;
    height: 40px;
  }
  .step_cont .van-steps{
    overflow: visible;
  }
  .step_cont .van-step--vertical:not(:last-child)::after{
    border-bottom-width: 0px;
  }
  .step_cont .step_cidesc{
    width: 480px;
    height: auto;
    font-size: 24px;
    font-weight: 400;
    color: #818282;
    line-height: 32px;
    padding-top: 24px;
    padding-bottom: 90px;
  }
  .step_citemsone{
    width: 100%;
    height: 289px;
  }
  .step_citemstwo{
    width: 100%;
    height: 321px;
  }
  .step_citemsthr{
    width: 100%;
    height: 289px;
  }
  .step_citemsfur{
    width: 100%;
    height: 289px;
  }
  .step_citemsfiv{
    width: 100%;
    height: 289px;
  }
  .step_citems_normal{
    width: 100%;
    height: 96px;
  }
  .step_cright{
    width: 350px;
    height: 604px;
    position: relative;
  }
  .step_cright_img{
    width: 350px;
    height: 604px;
    position: absolute;
    left: 0;
    top: -22px;
  }
  .step_cright_img img{
    display: block;
    width: 350px;
    height: 604px;
  }
</style>
